import { Badge } from "@/components/ui/badge";
import type { Persona } from "@/lib/orgContext";

const PERSONA_CONFIG: Record<Persona, { label: string; className: string }> = {
  Finance: {
    label: "Finance",
    className: "bg-emerald-500/10 text-emerald-700 border-emerald-200 dark:text-emerald-400 dark:border-emerald-800",
  },
  HR: {
    label: "HR",
    className: "bg-blue-500/10 text-blue-700 border-blue-200 dark:text-blue-400 dark:border-blue-800",
  },
  Legal: {
    label: "Legal",
    className: "bg-purple-500/10 text-purple-700 border-purple-200 dark:text-purple-400 dark:border-purple-800",
  },
  // AD = Athletic Director (top-exec role; currently inert pending future
  // top-exec workflows). Distinct from SA below.
  AD: {
    label: "Athletic Director",
    className: "bg-slate-500/10 text-slate-700 border-slate-200 dark:text-slate-300 dark:border-slate-700",
  },
  // SA = Sport Administrator (supervises coaches by sport; signs off on
  // coach contracts in their mapped sports).
  SA: {
    label: "Sport Administrator",
    className: "bg-amber-500/10 text-amber-700 border-amber-200 dark:text-amber-400 dark:border-amber-800",
  },
};

interface PersonaBadgeProps {
  persona: Persona;
  size?: "sm" | "xs";
}

export function PersonaBadge({ persona, size = "sm" }: PersonaBadgeProps) {
  const config = PERSONA_CONFIG[persona];
  if (!config) return null;
  return (
    <Badge
      variant="outline"
      className={`${config.className} ${size === "xs" ? "text-[10px] px-1.5 py-0" : "text-xs"}`}
    >
      {config.label}
    </Badge>
  );
}

export function PersonaBadgeList({ personas }: { personas: Persona[] | string[] }) {
  if (!personas || personas.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {personas.map((p) => (
        <PersonaBadge key={p} persona={p as Persona} />
      ))}
    </div>
  );
}

export { PERSONA_CONFIG };
